// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NtA8","colBig":"styles_colBig__10_g2","colSmall":"styles_colSmall__14JuO"};